import * as React from "react";
import Component from "../../AbstractComponent";

import { PromptDialog } from "./PromptDialog";
import { PageTransition } from "../Spinner/PageTransition";

import Constants from "../../../Action/Constants";


export class UndoSettleWithSavingsDialog extends Component {
  protected timer;

  public state = {
    entity: null,
    isOpen: false,
    isSaving: false,
    };

  constructor(public props) {
    super(props);
  }

  public componentWillReceiveProps(nextProps) {
    if (nextProps.entity !== this.state.entity) {
      this.setState({
        entity: nextProps.entity
      });
    }

    if (nextProps.isOpen !== this.state.isOpen) {
      this.setState({
        isOpen: nextProps.isOpen
      });
    }
  }

  public onCloseDialog = () => {
    if(this.props.closeDialog){
      this.props.closeDialog();

      this.clearState();
    }
  }

  public componentWillUnmount() {
    this.setState({
      entity: null,
      isOpen: false,
      isSaving: false,
    })
  }

  public clearState = () => {
    this.setState({
      entity: null,
      isOpen: false,
      isSaving: false,
    })
  }

  public save = () => {
    if(!this.state.entity) {
      return;
    }

    this.setState({
      isSaving: true
    });

    const payload = {
      chargeId: null,
      paymentId: null
    };

    if (this.state.entity?.nameForUrl === "charge") {
      payload.chargeId = this.state.entity?.id;
    } else {
      payload.paymentId = this.state.entity?.id;
    }

    this.props.dispatch({
      type: Constants.GLOBAL_UNDO_SETTLE_WITH_SAVINGS_ACCOUNT_START,
      payload,
      onSuccess: () => {
        this.props.dispatch({
          type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
        });

        this.setState({
          isSaving: false
        }, this.onCloseDialog);

        this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans("snackbar-message-undosettle-with-savings-successfully"),
            type: "success"
          }
        });

        return this.props.initializePage();
      },
      onError: () => {
        this.setState({
          isSaving: false,
        }, this.onCloseDialog);
        }
    });
  }

  public renderContent = () => {
    if (this.state.entity?.nameForUrl === "charge") {
      return (
        <div>{this.trans("dialog/preprocess-chargeundosettlewithsavings/info")}</div>
      );
    } else {
      return (
        <div>{this.trans("dialog/preprocess-paymentundosettlewithsavings/info")}</div>
      );
    }
  }

  public render() {
    return (
      <div>
        <PromptDialog
          {...this.props}
          openLeavePrompt={this.props.isOpen}
          title={this.trans("dialog/preprocess-undosettlewithsavings/title")}
          content={this.renderContent()}
          positiveButtonLabel={this.trans("dialog-button/continue")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={this.save}
          onDiscard={() => this.onCloseDialog()}
        />
                
        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}
